// extracted by mini-css-extract-plugin
module.exports = {"content":"_9e1425b4d3--content--KKx2S","footer-buttons":"_9e1425b4d3--footer-buttons--yFcCA"};